import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    
    getAll,
    editData,
    getFactories,
    getGroups,
    getFactories,
    getOperationalEntityByGroupEntityID,
    getGroupsForDropdown,
    getFactoryByGroupID,
    GetAllRoutesByFactoryID,
    searchCollectionCategoryroutes,
    GetAllDedtuctionTypeNames,
    getFactoryWeighReportDetails,
    getFeildDeductionTypeNames,
    getWeighDeductionTypeNames
};

async function getFeildDeductionTypeNames(data){
    let dailyCollectionReport = {
        grouptID: data.groupID,
        factoryID: data.factoryID,
        routeID: data.routeID,
        searchDate: data.searchdate,
        toDate: data.toDate
       
    }
    const response = await CommonPost('/api/DailyCollectionReport/GetAvailableDeductionTypesOfFeild', null, dailyCollectionReport);
    return response.data;
}

async function getWeighDeductionTypeNames(data){
    let dailyCollectionReport = {
        grouptID: data.groupID,
        factoryID: data.factoryID,
        routeID: data.routeID,
        searchDate: data.searchdate,
        toDate: data.toDate
       
    }
    const response = await CommonPost('/api/DailyCollectionReport/GetAvailableDeductionTypesOfFactoryWeigh', null, dailyCollectionReport);
    return response.data;
}

async function searchCollectionCategoryroutes(data){
    let dailyCollectionReport = {
        grouptID: data.groupID,
        factoryID: data.factoryID,
        routeID: data.routeID,
        searchDate: data.searchdate,
        toDate: data.toDate
       
    }
    const response = await CommonPost('/api/DailyCollectionReport/GetDailyReportCollection', null, dailyCollectionReport);
    return response.data;
}

async function getFactoryWeighReportDetails(data){
    let dailyCollectionReport = {
        grouptID: data.groupID,
        factoryID: data.factoryID,
        routeID: data.routeID,
        searchDate: data.searchdate,
        toDate: data.toDate
       
    }
    const response = await CommonPost('/api/DailyCollectionReport/GetDailyCollectionReportFactoryWeigh', null, dailyCollectionReport);
    return response.data;
}

async function getAll(){
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    return response.data;
}

async function editData(data) {
    data.modifiedDate = new Date().toISOString();
    data.operationEntityName = data.operationEntityName.trim();
    data.operationEntityLocation = data.operationEntityLocation.trim();
    data.groupID = parseInt(data.groupID);
    const response = await CommonPost('/api/OperationEntity/UpdateEstate', null, data);
    return response;
}

async function getFactories() {
    var factoryArray = []
    const response = await CommonGet('/api/Factory/GetAllFactories', null)
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true)
            factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
    }
    return factoryArray
}

async function getGroups() {
    var groupArray = []
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true)
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactoryByGroupID(id) {
    var factoryArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            factoryArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return factoryArray;
}

async function GetAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function GetAllDedtuctionTypeNames() {
    const response = await CommonGet('/api/DailyCollectionReport/GetDeductionTypeNamesForTable', null);
    return response.data;  
}
